import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { ExportBoxComponent }   from './export.box.component';
import { ExportComponent }      from './export.component';
import { ExportEmailComponent } from './export.email.component';
import { ExportService }        from './export.service';
import { ExportStates }         from './export.states';
import { SharedModule }         from '../shared/shared.module';

@NgModule({
  declarations: [
    ExportBoxComponent,
    ExportComponent,
    ExportEmailComponent
  ],
  entryComponents: [
    ExportBoxComponent,
    ExportComponent,
    ExportEmailComponent
  ],
  imports: [
    SharedModule,

    UIRouterUpgradeModule.forChild({ states: ExportStates })
  ],
  providers: [
    ExportService
  ]
})
export class ExportModule {}
